<app-form-delegate
    [add]="true"
    [fromUser]="fromUser"
    [toUser]="toUser"
    (onValidate)="validate($event)"
    (onCancel)="cancel()"
>
</app-form-delegate>
